import React from "react";
import { Image } from "react-bootstrap";

const SuspenseLoader = ({ message = "Loading..." }) => {
  return (
    <div className="suspense-loader" role="status" aria-live="polite">
      <Image
        src="/assets/images/loader-img.svg"
        className="rotating-loader"
        alt=""
        aria-hidden="true"
      />
      <span className="suspense-loader__text font-13 text-color">{message}</span>
    </div>
  );
};

export default SuspenseLoader;
